import { useAtom } from 'jotai';
import { createDcaWorkspaceAtom } from './atoms';

interface Args {
  parentType: string;
  parentId: number;
  additionalData?: Record<string, unknown>;
}

/**
 * Create a DCA Workspace and open it in a new tab.
 *
 * Extracted from `CreateDcaWorkspace` so the same behaviour can be triggered
 * from a menu item as well as from the standalone button — the button still
 * uses this, so there is one code path.
 *
 * @param {Args} args - Parent resource the workspace hangs off, plus any extra body fields.
 * @return {object} The trigger and its pending state.
 */
export function useCreateDcaWorkspace({
  parentType,
  parentId,
  additionalData,
}: Args) {
  const [{ loading }, mutate] = useAtom(createDcaWorkspaceAtom);

  const createDcaWorkspace = () => {
    mutate({
      type: 'POST',
      url: '/dca_workspaces',
      data: { parentType, parentId, ...additionalData },
      onSuccess: (data) => {
        window.open(data.href, '_blank');
      },
    });
  };

  return { createDcaWorkspace, loading };
}
